module.exports = __webpack_public_path__ + "static/media/account.1e3c2569.png";